/**
 * Copyright © 2026 Adnuntius AS.
 */
import {Component, Input} from '@angular/core';
import * as _ from 'lodash';
import {APP_SHARED} from '../common/app-shared';

@Component({
  standalone: true,
  imports: [...APP_SHARED],
  selector: 'adn-dimension-output',
  template: `
    <ng-container *ngIf="adUnit">
      <div *ngIf="isFixed">
        <span *ngFor="let dims of adUnit.dimensions; let last = last">
          {{dims[0]}}&times;{{dims[1]}}<span *ngIf="!last">, </span>
        </span>
      </div>
      <div *ngIf="!isFixed && hasFlexibleDimensions">{{adUnit.minWidth}}&times;{{adUnit.minHeight}} &ndash; {{adUnit.width}}&times;{{adUnit.height}}</div>
      <div *ngIf="adUnit.isFullPage">
        <span class="label label-success" style="margin-right: 4px">{{ 'highImpact.isFullPage' | ogTranslate }}</span>
        <span *ngFor="let format of adUnit.fullPageFormats" class="label label-default" style="margin-right: 4px">
          {{ ('highImpact.' + format) | ogTranslate }}
        </span>
      </div>
    </ng-container>
  `
})
export class DimensionOutputComponent {
  @Input() adUnit: any;

  get isFixed(): boolean {
    return _.get(this.adUnit, ['dimensions', 0, 0]) >= 0 && _.get(this.adUnit, ['dimensions', 0, 1]) >= 0;
  }

  get hasFlexibleDimensions(): boolean {
    return _.isFinite(this.adUnit?.minWidth) || _.isFinite(this.adUnit?.width);
  }
}
